import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "workspace-cockpit-dialog remove-padding p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.workspaceCockpitDialogDescriptor.style.flex,
    visible: _ctx.visible,
    modal: false,
    closable: false,
    position: "right",
    baseZIndex: 1,
    autoZIndex: true
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => []),
        end: _withCtx(() => [
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _ctx.close
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('common.close'),
              void 0,
              { bottom: true }
            ]
          ])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode("iframe", {
        ref: "iframe",
        class: "workspace-cockpit-iframe",
        src: _ctx.url
      }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}